var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-cost-units loading-content-container" },
    [
      _vm.costUnitListLoading > 0
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.costUnitListLoading === 0
        ? _c(
            "b-row",
            { staticClass: "mb-4" },
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 12,
                    icon: "inticon-users",
                    title: "Schadenpositionen",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _vm.permissions.canShowPaymentRequests
                        ? _c("csp-payment-request-modal", {
                            attrs: { "record-id": _vm.recordId },
                            on: { "payment-request-sent": _vm.loadCostUnits },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permissions.canCreateCostUnit &&
                      _vm.createModalAvailable
                        ? _c("csp-record-detail-cost-units-create", {
                            attrs: {
                              "form-context": _vm.creationFormContext,
                              "hide-for-group-options": _vm.hideForGroupOptions,
                              "record-id": _vm.recordId,
                            },
                            on: {
                              created: function ($event) {
                                _vm.loadCostUnits()
                                _vm.resetCreateModal()
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.addPaymentModalCostUnitId
                    ? _c("csp-record-detail-cost-unit-add-payment-modal", {
                        attrs: {
                          "cost-unit-id": _vm.addPaymentModalCostUnitId,
                          "form-context": _vm.costUnitPaymentFormContext,
                          "is-modal-open": _vm.shouldShowAddPaymentModal,
                          "record-id": _vm.recordId,
                        },
                        on: {
                          close: _vm.resetAddCarDealerPaymentModal,
                          updated: function ($event) {
                            return _vm.loadCostUnits()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editModalCostUnitId
                    ? _c("csp-record-detail-cost-unit-edit-modal", {
                        attrs: {
                          "cost-unit-id": _vm.editModalCostUnitId,
                          "form-context": _vm.costUnitFormContext,
                          "hide-for-group-options": _vm.hideForGroupOptions,
                          "is-modal-open": _vm.shouldShowCostUnitEditModal,
                          "record-id": _vm.recordId,
                        },
                        on: {
                          close: _vm.resetEditModal,
                          updated: function ($event) {
                            return _vm.loadCostUnits()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editModalCostUnitDraftId
                    ? _c("csp-record-detail-cost-unit-draft-edit-modal", {
                        attrs: {
                          "cost-unit-draft-id": _vm.editModalCostUnitDraftId,
                          "form-context": _vm.costUnitDraftFormContext,
                          "hide-for-group-options": _vm.hideForGroupOptions,
                          "is-modal-open": _vm.shouldShowCostUnitDraftEditModal,
                          "record-id": _vm.recordId,
                        },
                        on: {
                          close: _vm.resetEditModal,
                          updated: _vm.loadCostUnits,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detailModalCostUnitDraftId
                    ? _c("csp-record-detail-cost-unit-draft-detail-modal", {
                        attrs: {
                          "cost-unit-draft-id": _vm.detailModalCostUnitDraftId,
                          "hide-for-group-options": _vm.hideForGroupOptions,
                          "is-modal-open":
                            _vm.shouldShowCostUnitDraftDetailModal,
                          "record-id": _vm.recordId,
                        },
                        on: { close: _vm.resetDetailModal },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("csp-record-detail-cost-unit-detail-modal", {
                    attrs: {
                      "cost-unit-id": _vm.detailModalCostUnitId,
                      "hide-for-group-options": _vm.hideForGroupOptions,
                      "is-modal-open": _vm.shouldShowCostUnitDetailModal,
                      "record-id": _vm.recordId,
                    },
                    on: {
                      close: _vm.resetDetailModal,
                      updated: function ($event) {
                        return _vm.loadCostUnits()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cost-unit-list-table" },
                    [
                      _c("csp-record-detail-cost-units-list", {
                        attrs: {
                          "cost-unit-drafts": _vm.costUnitDrafts,
                          "cost-units": _vm.costUnits,
                          "hide-for-group-options": _vm.hideForGroupOptions,
                        },
                        on: {
                          "cost-unit-add-car-dealer-payment":
                            _vm.addCarDealerPayment,
                          "cost-unit-delete": _vm.deleteCostUnit,
                          "cost-unit-details": _vm.showCostUnitDetails,
                          "cost-unit-edit": _vm.showCostUnitEdit,
                          "cost-unit-verify": _vm.verifyCostUnit,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.costUnits.length
                    ? _c(
                        "div",
                        { staticClass: "cost-unit-legends collapse-body mt-5" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "legends col-md-4" }, [
                              _c("div", { staticClass: "legend" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-2 text-right" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "legend-symbol legend-adjustment",
                                        },
                                        [_vm._v("*")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-10" }, [
                                    _c("p", [
                                      _vm._v(
                                        "Betrag beinhaltet akzeptierte Minderung"
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "legend" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-2" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "legend-symbol legend-insurance",
                                      },
                                      [_vm._v(" ")]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-10" }, [
                                    _c("p", [
                                      _vm._v(
                                        "von der Versicherung zu begleichende Forderungen"
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.contextData
                                ? _c("div", { staticClass: "mt-2" }, [
                                    _c("div", [
                                      _vm._v(
                                        "\n                                Kunde ist vorsteuerabzugsberechtigt:\n                                " +
                                          _vm._s(
                                            _vm.contextData
                                              .customerIsVatDeductionEntitled
                                              ? "Ja"
                                              : "Nein"
                                          ) +
                                          "\n                            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                                Unfalldatum:\n                                " +
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.contextData.accidentDate
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-8" },
                              [
                                _c("csp-record-detail-cost-units-summary", {
                                  attrs: {
                                    "cost-unit-summary": _vm.costUnitSums,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.costUnitListLoading === 0 && _vm.permissions.canShowSapPayments
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { attrs: { cols: "8" } },
                [
                  _c("csp-table", {
                    ref: "sapPaymentsTable",
                    attrs: {
                      icon: "inticon-autoclaim_money",
                      "items-ajax-url": _vm.sapPaymentsAjaxUrl,
                      "row-class": _vm.sapPaymentsRowClass,
                      "table-headline": "Nicht zugeordnete SAP Zahlungen",
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.permissions.canCreateSapPayments
                          ? {
                              key: "above-body",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mb-3 right",
                                      attrs: { variant: "primary" },
                                      on: {
                                        click:
                                          _vm.createCostUnitPaymentsFromSap,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        Neu zuordnen\n                    "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.costUnitListLoading === 0 && _vm.recordLawsuit
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _vm.recordLawsuit &&
              _vm.initialFormContexts.recordLawsuit.isLoaded
                ? _c("csp-record-lawsuit", {
                    attrs: {
                      cols: 8,
                      "form-context": _vm.initialFormContexts.recordLawsuit,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.costUnitListLoading === 0 &&
      _vm.appraisals &&
      _vm.appraisals.length > 0
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 8,
                    icon: "inticon-autoclaim_billing",
                    title: "Forderungen TÜV SÜD",
                  },
                },
                [
                  _c("csp-record-appraisal-list", {
                    attrs: {
                      appraisals: _vm.appraisals,
                      "record-id": _vm.recordId,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.costUnitListLoading === 0 &&
      (_vm.hasBankAccountToShow || _vm.showRegressData)
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _vm.appraiserBankAccount
                ? _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("csp-record-detail-cost-unit-bank-account", {
                        attrs: {
                          "bank-account": _vm.appraiserBankAccount,
                          headline: "Bankverbindung Gutachter",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.carDealerBankAccount
                ? _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("csp-record-detail-cost-unit-bank-account", {
                        attrs: {
                          "bank-account": _vm.carDealerBankAccount,
                          headline: "Bankverbindung Autohaus",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerBankAccount
                ? _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("csp-record-detail-cost-unit-bank-account", {
                        attrs: {
                          "bank-account": _vm.customerBankAccount,
                          headline: "Bankverbindung Kunde",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showRegressData
                ? _c("csp-record-regress-data", {
                    attrs: {
                      cols: 4,
                      "form-context":
                        _vm.initialFormContexts.regressDataBasedata,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }